function Footer() {
  return <footer> ©2023 TWI Hellas - v0.6 </footer>;
}

export default Footer;
